import { z } from 'zod';
import { PaginationQuery } from '../../utils/listQuery';
import { listResponse } from '../../utils/listResponse';
import { configurationChangelogEntrySchema } from '../models/configurationChangelogEntry.schema';
import { configurationChangelogListQuerySchema } from './list.schema';

export type ConfigurationChangelogListQuery = PaginationQuery & {
  objectType?: Array<string>;
  objectId?: Array<number>;
  versionEvent?: Array<string>;
  modifierId?: Array<number>;
  changedFields?: string;
  versionCreatedAtAfter?: string;
  versionCreatedAtBefore?: string;
  versionId?: Array<number>;
  versionIdRangeMin?: number;
  versionIdRangeMax?: number;
  includeSnapshot?: boolean;
  q?: string;
};

export const list = (query: ConfigurationChangelogListQuery = {}) => {
  return {
    endpoint: `/configuration_changelog`,
    method: 'GET',
    responseSchema: listResponse(configurationChangelogEntrySchema),
    query: { ...query, includeTotal: true },
    querySchema: configurationChangelogListQuerySchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
  } as const;
};
